import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, Link } from "react-router-dom";
import axios from 'axios';
import IMG from '../image/O4P_ST_DTTD.jpg';
import IMG2 from '../image/CJS 8.jpg';
import SPARELOGO from '../image/spare-parts.png';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import CustomButton from "../Reusable/CustomButton";
import { BASE_URL } from "../../App";
import Swal from 'sweetalert2';
import { Card, Tooltip, Paper, TextField, Backdrop, CircularProgress, List, ListItem, ListItemText, ListItemAvatar, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Stack, SpeedDial, Grid, IconButton, Box } from '@mui/material';
import ErrorOutlineSharpIcon from '@mui/icons-material/ErrorOutlineSharp';
import KeyboardArrowUpSharpIcon from '@mui/icons-material/KeyboardArrowUpSharp';
import KeyboardArrowDownSharpIcon from '@mui/icons-material/KeyboardArrowDownSharp';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import CancelIcon from '@mui/icons-material/Cancel';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';

export default function SparePartsImage() {
    const navigate = useNavigate();
    const location = useLocation();
    const [AllProduct, setAllProduct] = useState([]);
    const [AvailableProduct, setAvailableProduct] = useState([]);
    const [NotEnabledProduct, setNotEnabledProduct] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [ProductImage, setProductImage] = useState([]);
    const [SpareDetail, setSpareDetail] = useState([]);
    const [OrderDetails, setOrderDetails] = useState([]);
    const [AvailableData, setAvailableData] = useState(true);
    const [AllData, setAllData] = useState(false);
    const [NotEnableData, setNotEnableData] = useState(false);
    const [isSparePopupOpen, setSparePopupOpen] = useState(false);
    const [isOrdersPopupOpen, setOrdersPopupOpen] = useState(false);

    const Dealer_Code = location.state && location.state.Dealer_Code;
    const Dealer_Name = location.state && location.state.Dealer_Name;
    const Order_Type = location.state && location.state.Order_Type;
    const Itemcode = location.state && location.state.Itemcode;
    const ITEMDESCRIPTION = location.state && location.state.ITEMDESCRIPTION;

    const handleClose = (orderQty) => {
        if (!orderQty) {
            Swal.fire({
                icon: "info",
                text: "Enter The Quantity !"
            }).then((result) => {
                setSparePopupOpen(true);
            });
        }
        setSparePopupOpen(false);
    };

    const handleOrderTableClose = () => {
        setOrdersPopupOpen(false);
    };

    const handleClick = (partNumber) => {
        // setClickedPartNumber(partNumber);
        setOpen(true);
        const data = { type: 'SpareDetail', Dealer_Code: Dealer_Code, Part_No: partNumber, Product_Code: Itemcode, Order_Type: Order_Type }
        axios.post(BASE_URL + '/siso', data)
            .then(response => {
                if (response.status === 200) {
                    setSpareDetail(response.data.message);
                    setSparePopupOpen(true);
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            })
            .catch(error => {
                // if (error.response) {
                    // Swal.fire({
                        // icon: "warning",
                        // text: `Error: ${error.response.data.message}`
                    // });
                // } else if (error.request) {
                    // console.error('No response received');
                // } else {
                    // console.error('Error setting up the request:', error.message);
                // }
            }).finally(() => {
                setOpen(false);
            });
    };

    const settings = {
        dots: true,
        zoom: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    useEffect(() => {
        GetAvailableProduct();
        GetAllProduct();
        GetNotEnableProduct();
        GetProductImage();
    }, []);

    const GetAllProduct = () => {
        if (Itemcode.trim() === '') {
            alert('Please Select Item!.');
            return;
        }

        setOpen(true);
        const data = { type: 'ProductDeatils', Details_Type: 'ALL', Product_Code: Itemcode, Dealer_Code: Dealer_Code }
        axios.post(BASE_URL + '/siso', data)
            .then(response => {
                if (response.status === 200) {
                    setAllProduct(response.data.message.ZFM_SD_DMS_SAP_SRV_BOMResponse.RESPONSE[0].BOM_COMP);
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            })
            .catch(error => {
                // if (error.response) {
                    // Swal.fire({
                        // icon: "info",
                        // text: `All ${error.response.data.message}`
                    // });
                // } else if (error.request) {
                    // console.error('No response received');
                // } else {
                    // console.error('Error setting up the request:', error.message);
                // }
            }).finally(() => {
                setOpen(false);
            });
    };

    const GetAvailableProduct = () => {
        if (Itemcode.trim() === '') {
            alert('Please Select Item!.');
            return;
        }

        setOpen(true);
        const data = { type: 'ProductDeatils', Details_Type: 'AVAILABLE', Product_Code: Itemcode, Dealer_Code: Dealer_Code }
        axios.post(BASE_URL + '/siso', data)
            .then(response => {
                if (response.status === 200) {
                    setAvailableProduct(response.data.message);
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            })
            .catch(error => {
                // if (error.response) {
                    // Swal.fire({
                        // icon: "info",
                        // text: error.response.data.message
                    // });
                // } else if (error.request) {
                    // console.error('No response received');
                // } else {
                    // console.error('Error setting up the request:', error.message);
                // }
            }).finally(() => {
                setOpen(false);
            });
    };

    const GetNotEnableProduct = () => {
        if (Itemcode.trim() === '') {
            alert('Please Select Item!.');
            return;
        }

        setOpen(true);
        const data = { type: 'ProductDeatils', Details_Type: 'NOT_ENABLE', Product_Code: Itemcode, Dealer_Code: Dealer_Code }
        axios.post(BASE_URL + '/siso', data)
            .then(response => {
                if (response.status === 200) {
                    setNotEnabledProduct(response.data.message);
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            })
            .catch(error => {
                // if (error.response) {
                    // Swal.fire({
                        // icon: "info",
                        // text: `Not Enabled ${error.response.data.message}`
                    // });
                // } else if (error.request) {
                    // console.error('No response received');
                // } else {
                    // console.error('Error setting up the request:', error.message);
                // }
            }).finally(() => {
                setOpen(false);
            });
    };

    const GetProductImage = () => {
        setOpen(true);
        const data = { type: 'ProductImage', Product_Code: Itemcode }
        axios.post(BASE_URL + '/siso', data)
            .then(response => {
                setProductImage(response.data.message);
            })
            .catch(error => {
                Swal.fire({
                    icon: "warning",
                    text: error.response.data.message
                });
            }).finally(() => {
                setOpen(false);
            });
    }

    const ViewOrders = () => {
        setOpen(true);

        const storedOrderId = localStorage.getItem("ORDER_ID") || '-';

        const data = { type: 'CartLoad', Order_ID: storedOrderId, Dealer_Code: Dealer_Code }
        axios.post(BASE_URL + '/siso', data).then(response => {
            if (response.status === 200) {
                setOrdersPopupOpen(true);
                setOrderDetails(response.data.message.data);
            } else {
                Swal.fire({
                    icon: "warning",
                    text: 'Unexpected response status. Please try again.'
                });
            }
        }).catch(error => {
            if (error.response) {
                Swal.fire({
                    icon: "info",
                    text: error.response.data.message
                });
                localStorage.removeItem("ORDER_ID");
            } else if (error.request) {
                console.error('No response received');
            } else {
                console.error('Error setting up the request:', error.message);
            }
        }).finally(() => {
            setOpen(false);
        });
    }

    const uniquePartNumbers = Array.from(new Set(AvailableProduct.map(item => item.PART_NUMBER)));

    return (
        <>
            <div className="m-4">
                <Card className="shadow bg-white rounded" sx={{ padding: '30px' }} >
                    <div className='row'>
                        <div className='col-md-6'>
                            <tr>
                                <td className="text-muted"><small>Dealer Code: </small></td>
                                <th>{Dealer_Code}</th>
                            </tr>
                            <tr>
                                <td className="text-muted"><small>Dealer Name: </small></td>
                                <th>{Dealer_Name}</th>
                            </tr>
                        </div>
                        <div className='col-md-6'>
                            <tr>
                                <td className="text-muted"><small>Product Code: </small></td>
                                <th>{Itemcode}</th>
                            </tr>
                            <tr>
                                <td className="text-muted"><small>Product Name: </small></td>
                                <th>{ITEMDESCRIPTION}</th>
                            </tr>
                            <tr>
                                <td className="text-muted"><small>Order Type: </small></td>
                                <th>{Order_Type}</th>
                            </tr>
                        </div>
                    </div>
                </Card>
                <br />
                <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} >
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Card className="shadow bg-white rounded" sx={{ padding: '30px' }} >
                    <div className='row'>
                        <div className='col-md-6'>
                            {ProductImage.IMAGES && ProductImage.IMAGES.length > 0 ? (
                                <div style={{ position: 'relative', width: '100%', maxWidth: '500px' }}>
                                    <Slider {...settings}>
                                        {ProductImage.IMAGES && ProductImage.IMAGES.map((PI, index) => (
                                            [PI.DWG1, PI.DWG2, PI.DWG3, PI.DWG4, PI.DWG5, PI.MOTOR_IMG, PI.PUMP_IMG].filter(image => image).map((image, imgIndex) => (
                                                <div key={`${index}-${imgIndex}`}>
                                                    <div style={{ position: 'relative' }}>
                                                        <img src={ProductImage.BASE_IMAGE_PATH + image} alt="Spare Parts" style={{ width: '100%' }} />
                                                    </div>
                                                </div>
                                            ))
                                        ))}
                                    </Slider>
                                    <br />
                                    <br />
                                </div>
                            ) : (
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', maxWidth: '500px', height: 'auto', margin: '0 auto' }}>
                                    <center>
                                        <img src={ProductImage.NOT_FOUND_IMAGE} alt="Spare Parts" style={{ width: '100%' }} />
                                    </center>
                                </div>
                            )}
                        </div>
                        <div className='col-md-6 mt-2'>
                            <div className="p-2 mt-2" style={{ borderRadius: '10px', color: '#0d6efd', backgroundImage: 'linear-gradient(to right, #2e7fc2 0%, #6acad2 100%)' }} onClick={() => setAvailableData(!AvailableData)}>
                                <center className="text-white">
                                    <b>Available Items</b>
                                    <span style={{ float: 'right' }}>
                                        {AvailableData ? "Hide" : "Show"} {AvailableData ? <KeyboardArrowUpSharpIcon /> : <KeyboardArrowDownSharpIcon />}
                                    </span>
                                </center>
                            </div>
                            {AvailableData && (
                                <>
                                    <div style={{ overflowY: 'auto', maxHeight: '450px' }}>
                                        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                                            {uniquePartNumbers.length > 0 ? (
                                                <>
                                                    {uniquePartNumbers.map(partNumber => {
                                                        const PD = AvailableProduct.find(item => item.PART_NUMBER === partNumber);
                                                        return (
                                                            PD.PART_NUMBER ? (
                                                                <Card className="shadow bg-white rounded" sx={{ padding: '0px', margin: '10px', cursor: 'pointer' }} onClick={() => handleClick(PD.PART_NUMBER)} key={PD.PG_code}>
                                                                    <ListItem alignItems="flex-start">
                                                                        <ListItemAvatar>
                                                                            <center>
                                                                                <SettingsSuggestIcon sx={{ color: '#1976D2', fontSize: '40px' }} />&emsp;
                                                                            </center>
                                                                        </ListItemAvatar>
                                                                        <ListItemText
                                                                            primary={<b>{PD.PART_NUMBER} | {PD.PART_NAME}</b>}
                                                                            secondary={
                                                                                <React.Fragment>
                                                                                    <Typography
                                                                                        sx={{ display: 'inline' }}
                                                                                        component="span"
                                                                                        variant="body2"
                                                                                        color="text.primary"
                                                                                    ></Typography>
                                                                                    {PD.COMPONENT_CODE} | {PD.MATERIAL_DESC}
                                                                                </React.Fragment>
                                                                            }
                                                                        />
                                                                    </ListItem>
                                                                </Card>
                                                            ) : (
                                                                <Card className="shadow bg-white rounded" sx={{ padding: '0px', margin: '10px' }} key={PD.PG_code}>
                                                                    <ListItem alignItems="flex-start">
                                                                        <ListItemAvatar>
                                                                            <ErrorOutlineSharpIcon sx={{ color: '#EB1203', fontSize: '48px' }} /> {/* Increased fontSize */}
                                                                        </ListItemAvatar>
                                                                        <ListItemText
                                                                            primary={
                                                                                <span className="text-danger"> Part Number Not Found!</span>
                                                                            }
                                                                            secondary={
                                                                                <React.Fragment>
                                                                                    <Typography
                                                                                        sx={{ textAlign: 'center' }}
                                                                                        component="span"
                                                                                        variant="body2"
                                                                                        color="text.primary"
                                                                                    ></Typography>
                                                                                    {PD.MATERIAL_DESC}
                                                                                </React.Fragment>
                                                                            }
                                                                        />
                                                                    </ListItem>
                                                                </Card>
                                                            )
                                                        );
                                                    })}
                                                </>
                                            ) : (
                                                <>
                                                    <div style={{ overflowY: 'auto', maxHeight: '450px' }}>
                                                        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                                                            <Card className="shadow bg-white rounded" sx={{ padding: '0px', margin: '10px' }}>
                                                                <ListItem alignItems="flex-start">
                                                                    <ListItemAvatar>
                                                                        <ErrorOutlineSharpIcon sx={{ color: '#EB1203', fontSize: '48px' }} />
                                                                    </ListItemAvatar>
                                                                    <ListItemText
                                                                        primary={
                                                                            <span className="text-danger"> Details Not Found!</span>
                                                                        }
                                                                    />
                                                                </ListItem>
                                                            </Card>
                                                        </List>
                                                    </div>
                                                </>
                                            )}
                                        </List>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="mt-3">
                        <div className="p-2" style={{ borderRadius: '10px', color: '#0d6efd', backgroundImage: 'linear-gradient(to right, #2e7fc2 0%, #6acad2 100%)' }} onClick={() => setAllData(!AllData)}>
                            <center className="text-white">
                                <b>All Items</b>
                                <span style={{ float: 'right' }}>
                                    {AllData ? "Hide" : "Show"} {AllData ? <KeyboardArrowUpSharpIcon /> : <KeyboardArrowDownSharpIcon />}
                                </span>
                            </center>
                        </div>
                        {AllData && (
                            <>
                                {AllProduct && AllProduct.length > 0 ? (
                                    <>
                                        <div className="row row-cols-lg-4 row-cols-md-3 mt-2" style={{ overflowY: 'auto', maxHeight: '250px' }}>
                                            {AllProduct && AllProduct.map((PD) => (
                                                <div className='col-6' key={PD.PG_code}>
                                                    {PD.PART_NUMBER ? (
                                                        <Card className="shadow bg-white rounded" sx={{ padding: '10px', margin: '10px', backgroundImage: 'linear-gradient(to right, #6acad2 0%, #e4f2f3 100%)' }}>
                                                            <div>
                                                                <center>
                                                                    {/* <SettingsSuggestIcon sx={{ color: '#1976D2', fontSize: '30px', float: 'left' }} /> */}
                                                                    {/* <b>{PD.PART_NUMBER} | {PD.PART_NAME}</b><br /> */}
                                                                    <SettingsSuggestIcon sx={{ color: '#1976D2', fontSize: '30px', float: 'left' }} />
                                                                    <Typography variant="h6" style={{ fontWeight: 'bold', fontSize: '16px', color: '#333' }}>
                                                                        {PD.PART_NUMBER} | {PD.PART_NAME}
                                                                    </Typography><br />
                                                                    <Typography variant="body2" style={{ color: '#888', fontSize: '10' }}>
                                                                        {PD.COMPONENT_CODE} | {PD.MATERIAL_DESC}
                                                                    </Typography>
                                                                </center>
                                                            </div>
                                                        </Card>
                                                    ) : (
                                                        <Card className="shadow bg-white rounded" sx={{ padding: '5px', margin: '10px', backgroundImage: 'linear-gradient(to right, #6acad2 0%, #e4f2f3 100%)' }}>
                                                            <div>
                                                                <center>
                                                                    <ErrorOutlineSharpIcon sx={{ color: '#EB1203' }} /><br /><span className="text-danger"> Part Number Not Found!</span>
                                                                </center>
                                                            </div>
                                                        </Card>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <Card className="shadow bg-white rounded" sx={{ padding: '5px', margin: '10px', backgroundImage: 'linear-gradient(to right, #6acad2 0%, #e4f2f3 100%)' }}>
                                            <div>
                                                <center>
                                                    <ErrorOutlineSharpIcon sx={{ color: '#EB1203' }} /><br /><span className="text-danger"> All Items Details Not Found.!</span>
                                                </center>
                                            </div>
                                        </Card>
                                    </>
                                )}
                            </>
                        )}
                    </div>
                    <div className="mt-3">
                        <div className="p-2" style={{ borderRadius: '10px', color: '#0d6efd', backgroundImage: 'linear-gradient(to right, #2e7fc2 0%, #6acad2 100%)' }} onClick={() => setNotEnableData(!NotEnableData)}>
                            <center className="text-white">
                                <b>Not Enabled Items</b>
                                <span style={{ float: 'right' }}>
                                    {NotEnableData ? "Hide" : "Show"} {NotEnableData ? <KeyboardArrowUpSharpIcon /> : <KeyboardArrowDownSharpIcon />}
                                </span>
                            </center>
                        </div>
                        {NotEnableData && (
                            <>
                                {NotEnabledProduct && NotEnabledProduct.length > 0 ? (
                                    <>
                                        <div className="row row-cols-lg-4 row-cols-md-3 mt-2" style={{ overflowY: 'auto', maxHeight: '250px' }}>
                                            {NotEnabledProduct && NotEnabledProduct.map((PD) => (
                                                <div className='col-6' key={PD.PG_code}>
                                                    {PD.PART_NUMBER ? (
                                                        <Card className="shadow bg-white rounded" sx={{ padding: '10px', margin: '10px', backgroundImage: 'linear-gradient(to right, #6acad2 0%, #e4f2f3 100%)' }}>
                                                            <div>
                                                                <center>
                                                                    {/* <SettingsSuggestIcon sx={{ color: '#1976D2', fontSize: '30px', float: 'left' }} />
                                                            <b>{PD.PART_NUMBER} | {PD.PART_NAME}</b><br />
                                                            <span className="text-secondary">{PD.COMPONENT_CODE} | {PD.MATERIAL_DESC}</span> */}
                                                                    <SettingsSuggestIcon sx={{ color: '#1976D2', fontSize: '30px', float: 'left' }} />
                                                                    <Typography variant="h6" style={{ fontWeight: 'bold', fontSize: '16px', color: '#333' }}>
                                                                        {PD.PART_NUMBER} | {PD.PART_NAME}
                                                                    </Typography><br />
                                                                    <Typography variant="body2" style={{ color: '#888', fontSize: '10' }}>
                                                                        {PD.COMPONENT_CODE} | {PD.MATERIAL_DESC}
                                                                    </Typography>
                                                                </center>
                                                            </div>
                                                        </Card>
                                                    ) : (
                                                        <Card className="shadow bg-white rounded" sx={{ padding: '5px', margin: '10px', backgroundImage: 'linear-gradient(to right, #6acad2 0%, #e4f2f3 100%)' }}>
                                                            <div>
                                                                <center>
                                                                    <ErrorOutlineSharpIcon sx={{ color: '#EB1203' }} /><br /><span className="text-danger"> Part Number Not Found!</span>
                                                                </center>
                                                            </div>
                                                        </Card>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                        <span className="text-danger" style={{ float: 'right' }}><b>* Please Contact Branch To Enable These Items</b></span>
                                    </>
                                ) : (
                                    <>
                                        <Card className="shadow bg-white rounded" sx={{ padding: '5px', margin: '10px', backgroundImage: 'linear-gradient(to right, #6acad2 0%, #e4f2f3 100%)' }}>
                                            <div>
                                                <center>
                                                    <ErrorOutlineSharpIcon sx={{ color: '#EB1203' }} /><br /><span className="text-danger"> Not Enabled Items Details Not Found.!</span>
                                                </center>
                                            </div>
                                        </Card>
                                    </>
                                )}
                            </>
                        )}
                    </div>
                </Card>
                <br />
                <SpeedDial
                    ariaLabel="Orders"
                    sx={{ position: 'fixed', bottom: 30, right: 30 }}
                    icon={<ShoppingCartIcon />}
                    onClick={ViewOrders}
                    open={!isSparePopupOpen}
                >
                </SpeedDial>
                {isSparePopupOpen && (
                    <SpareDetailPopup data={SpareDetail} onClose={handleClose} dealercode={Dealer_Code} />
                )}
                {isOrdersPopupOpen && (
                    <OrderTable onClose={handleOrderTableClose} data={OrderDetails} />
                )}
            </div>
            <br />
            <br />
        </>
    );
}

const SpareDetailPopup = ({ data, onClose, dealercode }) => {

    const [open, setOpen] = React.useState(false);
    const [orderQty, setOrderQty] = useState("");
    const [ItemSelect, setItemSelect] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [ErrorMsg, setErrorMsg] = useState('');
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);

    const handleCardClick = (item) => {
        setSelectedItem(item);
    };

    const handleQtyChange = (event) => {
        const input = event.target.value;
        const numbersOnly = input.replace(/\D/g, '');
        const truncatedInput = numbersOnly.slice(0, 7);
        setOrderQty(truncatedInput);

        const DB_QTY = data[0].PACK_QTY;
        const ENTER_QTY = truncatedInput;
		
		if(!ENTER_QTY){
			setErrorMsg("Enter the quantity.!");
			setIsButtonDisabled(true);
		}

        const F_QTY = ENTER_QTY / DB_QTY;

        if (F_QTY !== Math.round(F_QTY)) {
            //setErrorMsg("Check The Pack Qty And Enter the Pack Qty Multiple Value");
            setErrorMsg("Enter the quantity in multiples of "+ DB_QTY +".!");
            setIsButtonDisabled(true);
        } else {
            setErrorMsg("");
            setIsButtonDisabled(false);
        }
    };

    const AddToCart = () => {
        setOpen(true);
        if (!orderQty) {
            onClose(orderQty);
            setOpen(false);
            return false;
        }

        let ORDER_ID;

        const storedOrderId = localStorage.getItem("ORDER_ID");
        const LOGIN_ID = localStorage.getItem("LOGIN_ID");
        if (storedOrderId === null || storedOrderId === undefined) {
            ORDER_ID = 'NEW';
        } else {
            ORDER_ID = storedOrderId;
        }

        const item = data[0];
        const Data = {
            type: 'Order',
            Order_ID: ORDER_ID,
            Dealer_Code: dealercode,
            Product_Code: item.MATERIAL,
            Component_Code: item.COMPONENT_CODE,
            Rate: item.FINAL_AMOUNT,
            PO_Type: item.ORDER_TYPE,
            ORDER_QTY: orderQty,
            Login_User_Id: LOGIN_ID
        }

        axios.post(BASE_URL + '/siso', Data)
            .then(response => {
                if (response.status === 200) {
                    localStorage.setItem('ORDER_ID', response.data.message.orderid);
                    onClose(orderQty);
                    Swal.fire({
                        icon: "success",
                        title: response.data.message.message,
                        //text: 'Order Id is ' + response.data.message.orderid
                    });
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                    onClose(orderQty);
                }
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: error.response.data.message
                    });
                    onClose(orderQty);
                } else if (error.request) {
                    console.error('No response received');
                    onClose(orderQty);
                } else {
                    console.error('Error setting up the request:', error.message);
                    onClose(orderQty);
                }
            }).finally(() => {
                setOpen(false);
            });

    }

    return (
        <Dialog open={true} onClose={onClose} maxWidth="sm" fullWidth sx={{ justifyContent: 'center' }}>
            <DialogTitle>
                <center><u><b>Spare Part Detail</b></u></center>
            </DialogTitle>
            <DialogContent>
                <>
                    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    {!selectedItem && (
                        <div className="row">
                            {data.map(item => (
                                <div className="col-md-6 mt-2" key={item.COMPONENT_CODE}>
                                    <Card className="shadow bg-secondary rounded" sx={{ padding: '0px', cursor: 'pointer', backgroundImage: 'linear-gradient(to right, #6acad2 0%, #e4f2f3 100%)' }}
                                        onClick={() => handleCardClick(item)}>
                                        <ListItem alignItems="flex-start">
                                            <ListItemAvatar>
                                                <center>
                                                    <img src={SPARELOGO} alt="LOGO" style={{ width: '50px' }} />
                                                </center>
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={
                                                    <b>
                                                        {item.PART_NUMBER} | {item.PART_NAME}
                                                    </b>
                                                }
                                                secondary={
                                                    <React.Fragment>
                                                        <Typography
                                                            sx={{ display: 'inline' }}
                                                            component="span"
                                                            variant="body2"
                                                            color="text.primary"
                                                        ></Typography>
                                                        {item.MATERIAL_DESC}
                                                    </React.Fragment>
                                                }
                                            />
                                        </ListItem>
                                    </Card>
                                </div>
                            ))}
                        </div>
                    )}
                    {selectedItem && (
                        <>
                            <small style={{ float: 'right', color: 'blue' }} onClick={() => setSelectedItem(null)}><KeyboardDoubleArrowLeftIcon />Change Item</small>
                            <div key={selectedItem.PART_NUMBER}>
                                <h4><center>{selectedItem.PART_NUMBER} | {selectedItem.PART_NAME}</center></h4>
                                <div className="row mt-3">
                                    <div className="col">
                                        <TextField size="small" fullWidth disabled label="COMPONET-CODE" variant="outlined" value={selectedItem.COMPONENT_CODE} />
                                    </div>
                                    <div className="col">
                                        <TextField size="small" fullWidth disabled label="RATE" variant="outlined" value={selectedItem.FINAL_AMOUNT} />
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col">
                                        <TextField size="small" fullWidth disabled label="MATERIAL_DESC" variant="outlined" value={selectedItem.MATERIAL_DESC} />
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col">
                                        <TextField size="small" fullWidth disabled label="ORDER-TYPE" variant="outlined" value={selectedItem.ORDER_TYPE} />
                                    </div>
                                    <div className="col">
                                        <TextField size="small" fullWidth disabled label="PACK-QTY" variant="outlined" value={selectedItem.PACK_QTY} />
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <div className="col">
                                        <TextField size="small" fullWidth required label="ENTER ORDER-QTY" variant="outlined" value={orderQty} onChange={handleQtyChange} />
                                    </div>
                                    {ErrorMsg &&
                                        <>
                                            <br />
                                            <center>
                                                <span style={{ color: 'red' }}>* {ErrorMsg}</span>
                                            </center>
                                        </>
                                    }
                                </div>
                            </div>
                        </>
                    )}
                </>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center' }}>
                <Stack directi on="row" spacing={2} sx={{ width: '100%', maxWidth: '400px' }}>
                    {!selectedItem ? (
                        <center>
                            <CustomButton
                                label={<>Cancel&nbsp;<CancelIcon sx={{ fontSize: '20px' }} /></>}
                                onClick={onClose}
                                variant="outlined"
                                color="error"
                                fullWidth
                                width="200px"
                            />
                        </center>
                    ) : (
                        <center>
                            {selectedItem.FINAL_AMOUNT == 0 ? (
                                <Tooltip title="This Item Rate Not Available.!">
                                    <CustomButton
                                        label={<>Add To Cart&nbsp;<ShoppingCartIcon sx={{ fontSize: '20px' }} /></>}
                                        onClick={AddToCart}
                                        variant="outlined"
                                        fullWidth
                                        width="150px"
                                        disabled
                                    />
                                </Tooltip>
                            ) : (
                                <CustomButton
                                    label={<>Add To Cart&nbsp;<ShoppingCartIcon sx={{ fontSize: '20px' }} /></>}
                                    onClick={AddToCart}
                                    variant="outlined"
                                    fullWidth
                                    width="150px"
                                    disabled={isButtonDisabled}
                                />
                            )}
                            &emsp;
                            <CustomButton
                                label={<>Cancel&nbsp;<CancelIcon sx={{ fontSize: '20px' }} /></>}
                                onClick={onClose}
                                variant="outlined"
                                color="error"
                                fullWidth
                                width="150px"
                            />
                        </center>
                    )}
                </Stack>
            </DialogActions>
        </Dialog>
    );
}


const OrderTable = ({ data, onClose }) => {

    const [open, setOpen] = React.useState(false);

    const RemoveSpare = (SpareId) => {
        setOpen(true);

        const storedOrderId = localStorage.getItem("ORDER_ID");

        const Data = { type: 'SpareRemove', Order_ID: storedOrderId, Spare_Code: SpareId }

        axios.post(BASE_URL + '/siso', Data)
            .then(response => {
                if (response.status === 200) {
                    Swal.fire({
                        icon: "success",
                        text: response.data.message
                    });
                    onClose();
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                    onClose();
                }
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: error.response.data.message
                    });
                    onClose();
                } else if (error.request) {
                    console.error('No response received');
                    onClose();
                } else {
                    console.error('Error setting up the request:', error.message);
                    onClose();
                }
            }).finally(() => {
                setOpen(false);
            });
    }

    const SubmitOrder = () => {
        setOpen(true);
        const storedOrderId = localStorage.getItem("ORDER_ID");

        const Data = { type: 'SubmitOrder', Order_ID: storedOrderId }

        axios.post(BASE_URL + '/siso', Data)
            .then(response => {
                if (response.status === 200) {
                    // Swal.fire({
                        // icon: "success",
                        // title: response.data.message[0],
                        // text: response.data.message[1]
                    // });
					Swal.fire({
						icon: 'success',
						title: response.data.message.SAP_MSG,
						html: `<p>Order No :  ${response.data.message.DOC_NO}</p><p>Ref# SAP No : ${response.data.message.SAP_NO}</p>`,
					})
                    localStorage.removeItem("ORDER_ID");
                    onClose();
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                    onClose();
                }
            }).catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: error.response.data.message
                    });
                    onClose();
                } else if (error.request) {
                    console.error('No response received');
                    onClose();
                } else {
                    console.error('Error setting up the request:', error.message);
                    onClose();
                }
            }).finally(() => {
                setOpen(false);
            });
    }

    let total = 0;
    return (
        <>
            <Dialog open={true} onClose={onClose} maxWidth="xl" fullWidth sx={{ justifyContent: 'center' }}>
                <DialogTitle><center><u><b>Order Detail</b></u></center></DialogTitle>
                <DialogContent>
                    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 100 }} open={open} >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <div className="row mb-3">
                        <div className="col">
                            <center>
                                <b>Order ID: {localStorage.getItem("ORDER_ID")}</b>
                            </center>
                        </div>
                    </div>
                    {/* storedOrderId */}
                    <div className="" style={{ overflowY: 'auto', maxHeight: '500px' }}>
                        {data && data.map(item => (
                            <Card className="rounded mb-2" sx={{ padding: '10px', boxShadow: '0 2px 4px 0 rgba(0,0,0,0.1)', border: '1px solid #e0e0e0', backgroundImage: 'linear-gradient(to right, #6acad2 0%, #e4f2f3 100%)' }}>
                                <Grid container alignItems="center">
                                    <Grid item xs={2} sm={2}>
                                        <SettingsSuggestIcon sx={{ color: '#1976D2', fontSize: '40px' }} />&emsp;
                                        {/* <img src={SPARELOGO} alt="LOGO" style={{width:'50px'}} /> */}
                                    </Grid>
                                    &nbsp;
                                    <Grid item xs={8} sm={8}>
                                        <Typography variant="subtitle1" color="textPrimary" gutterBottom>
                                            <span style={{ color: '#2874f0' }}>{item.spare_code}</span> | {item.spare_description}
                                        </Typography>
                                        <Grid container spacing={1}>
                                            <Grid item xs={6} sm={6}>
                                                <Typography variant="body2" color="textSecondary">
                                                    <b>Order QTY:</b> {item.spare_qty}
                                                </Typography>
                                                <Typography variant="body2" color="textSecondary">
                                                    <b>Type:</b> {item.po_type}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6} sm={6}>
                                                <Typography variant="body2" color="textSecondary">
                                                    <b>Price:</b> ₹{parseFloat(item.listprice).toFixed(2)}
                                                </Typography>
                                                <Typography variant="body2" color="textSecondary">
                                                    <b>Total:</b> ₹{parseFloat(item.amount).toFixed(2)}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={1} sm={1}>
                                        <IconButton color="primary" onClick={() => RemoveSpare(item.spare_code)}>
                                            <DeleteForeverIcon />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            </Card>
                        ))}
                    </div>
                    <Card className="shadow bg-white rounded mb-2" sx={{ padding: '2px', backgroundImage: 'linear-gradient(to right, #6acad2 0%, #e4f2f3 100%)' }}>
                        {data && data.forEach(item => {
                            total += parseFloat(item.amount);
                        })}
                        <div className="row">
                            <div className="col-6"><b>&emsp;Total Amount:</b></div>
                            <div className="col-6">{total.toFixed(2)}</div>
                        </div>
                    </Card>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'center' }}>
                    <Stack direction="row" spacing={2} sx={{ width: '100%', maxWidth: '400px' }}>
                        <CustomButton
                            label={<>Place Order&nbsp;<ShoppingBasketIcon sx={{ fontSize: '20px' }} /></>}
                            onClick={SubmitOrder}
                            variant="outlined"
                            fullWidth
                            width="200px"
                        />
                        <CustomButton
                            label={<>Cancel&nbsp;<CancelIcon sx={{ fontSize: '20px' }} /></>}
                            onClick={onClose}
                            variant="outlined"
                            color="error"
                            fullWidth
                            width="200px"
                        />
                    </Stack>
                </DialogActions>
            </Dialog>
        </>
    );
}